export const EVENT_ID_PARAM_KEY = 'eventId'
export const TRACKING_ID_PARAM_KEY = 'trackingId'
